export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-refresher/index.js